class CustomRangeSlider extends HTMLElement {
  constructor() {
    super();

    this.isDragging = false;
  }

  onDrag = theme.utils.throttle(50, (e) => {
    if (!this.isDragging) return;

    const rect = this.sliderTrackEl.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const percent = Math.min(Math.max(x / rect.width, 0), 1);
    const value = Math.round(this.min + percent * (this.max - this.min));

    this.sliderInputEl.value = value;
    this.sliderInputEl.dispatchEvent(new Event('change'));
    this.sliderLabelValueEl.textContent = value;

    this.updateThumbPosition(percent);
  });

  stopDrag = () => {
    this.isDragging = false;
    document.removeEventListener('pointermove', this.onDrag);
    document.removeEventListener('pointerup', this.stopDrag);
  };

  startDrag = (e) => {
    e.preventDefault();
    this.isDragging = true;

    this.sliderTrackEl.setPointerCapture(e.pointerId);

    document.addEventListener('pointermove', this.onDrag);
    document.addEventListener('pointerup', this.stopDrag);
    this.onDrag(e);
  };

  updateThumbPosition = (percent, useDefaultValue = false) => {
    let actualPercent = percent;

    if (useDefaultValue) {
      this.sliderLabelValueEl.textContent = this.sliderInputEl.value;
      actualPercent =
        (this.sliderInputEl.value - this.min) / (this.max - this.min);
    }

    const pos = actualPercent * this.sliderTrackEl.offsetWidth || 0;

    this.sliderThumbEl.style.left = `${pos}px`;
    this.sliderThumbEl.style.transform = `translateX(-${Math.round(actualPercent * 100)}%)`;
    this.sliderFilledEl.style.width = `${pos}px`;

    if (actualPercent < 0.05) {
      this.sliderLabelValueEl.parentElement.style.left = '0';
      this.sliderLabelValueEl.parentElement.style.translate = '0';
    } else if (actualPercent > 0.95) {
      this.sliderLabelValueEl.parentElement.style.left = '10%';
      this.sliderLabelValueEl.parentElement.style.translate = '-50% 0';
    } else {
      this.sliderLabelValueEl.parentElement.style.left = '50%';
      this.sliderLabelValueEl.parentElement.style.translate = '-50% 0';
    }
  };

  connectedCallback() {
    this.sliderInputEl = this.querySelector('.js-range-slider-input');
    this.sliderTrackEl = this.querySelector('.js-range-slider-track');
    this.sliderFilledEl = this.querySelector('.js-range-slider-filled');
    this.sliderThumbEl = this.querySelector('.js-range-slider-thumb');
    this.sliderLabelValueEl = this.querySelector('.js-range-slider-value');

    this.min = Number(this.sliderInputEl.min);
    this.max = Number(this.sliderInputEl.max);

    this.sliderTrackEl.addEventListener('pointerdown', this.startDrag);
    this.sliderInputEl.addEventListener('input', () => {
      this.updateThumbPosition(0, true);
    });

    this.updateThumbPosition(0, true);
  }
}

if (!customElements.get('custom-range-slider')) {
  customElements.define('custom-range-slider', CustomRangeSlider);
}
